<template>
  <div id="home">
    <div class="teams">
      <Following
        v-for="item in teams"
        :key="item.team.id"
        :item="item"
        class="item"
      ></Following>
      <!-- <div v-for="item in teams" :key="item.team.id" class="item">
        <div class="header">
          <div
            class="logo"
            :style="{ backgroundImage: 'url(' + item.club.shield + ')' }"
          ></div>
          <div class="name">
            {{ item.club.name }} - {{ item.team.category }}
          </div>
        </div>
      </div> -->
    </div>
    <div class="categories">
      <router-link
        v-for="category in categories"
        :key="category.id"
        class="item"
        :to="'competition/' + category.id"
      >
        <div class="name">{{ category.name }}</div>
        <div class="description">{{ category.year }}</div>
      </router-link>
    </div>

    <div class="partners">
      <div class="title">{{ $t("miclive.home.partners") }}</div>
      <img
        class="sponsor"
        :src="sponsor"
        loading="lazy"
        height="300"
      />
    </div>
  </div>
</template>

<script>
import Following from "@/components/domain/competition/following";

export default {
  name: "Home",
  components: { Following },
  data() {
    return {};
  },
  computed: {
    categories() {
      return this.$store.getters["competition/getCategories"]();
    },
    clubs() {
      return this.$store.getters["competition/getClubs"]();
    },
    teams() {
      return this.$store.getters["competition/getTeamsFollowing"];
    },
    sponsor() {
      var result = this.$store.getters["getSponsors"]("live");
      return result || false;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.categories {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  row-gap: 10px;
  text-align: center;

  .item {
    background-color: $main-color;
    color: #fff;
    border-radius: 4px;
    padding: 35px 10px;
    align-items: center;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    transition: all 0.3s;

    .name {
      font-family: $font-title;
      font-size: 24px;
    }
    .description {
    }
    &:hover {
      background-color: $secondary-color;
      color: #222;
    }
  }
}

.teams {
  grid-template-columns: minmax(0, 1fr);
  column-gap: 10px;
  display: grid;
  margin-bottom: 20px;
}

.partners {
  margin-top: 40px;
  text-align: center;
  .title {
    text-align: center;
    font-family: $font-text;
  }
  .logo {
    width: 100%;
    max-width: 500px;
  }
}

.tablet {
  .categories {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}
.laptop {
  .categories {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(
        0,
        1fr
      ) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}
.desktop {
  .categories {
    grid-template-columns:
      minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)
      minmax(0, 1fr) !important;
  }
  .teams {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}
</style>
